module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', {
    attrs: {
      "indicator-inside": false
    },
    scopedSlots: _vm._u([{
      key: "indicators",
      fn: function(props) {
        return [_c('span', {
          staticClass: "al image"
        }, [_c('img', {
          attrs: {
            "src": _vm.getImgUrl(props.i),
            "title": props.i
          }
        })])]
      }
    }])
  }, _vm._l((6), function(item, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('span', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgUrl(i)
      }
    })])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787c80b2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExCustomIndicator.vue
// module id = 991
// module chunks = 3 49